var _path, _path2, _mask, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9531 62.9038H71.1163L74.1111 73.9881H18.9531V62.9038ZM18.9534 73.9882H166.583V181H18.9534V73.9882Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.318 141C136.64 132.761 108.604 124.621 81 116.559C87.9419 83.9781 107.392 52.0611 108.715 19C137.367 26.7655 165.383 34.5311 193 42.3295C185.934 75.4235 166.51 107.643 165.318 141Z",
    fill: "#E8ECEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1552_71073",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 73H57.8519L62 83H154.614L166 181H18.3858L7 83H7.17117L6 73Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 73H57.8519L62 83H154.614L166 181H18.3858L7 83H7.17117L6 73Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8519 73L59.6992 72.2337L59.1875 71H57.8519V73ZM6 73V71H3.7521L4.01358 73.2326L6 73ZM62 83L60.1526 83.7663L60.6644 85H62V83ZM154.614 83L156.601 82.7692L156.395 81H154.614V83ZM166 181V183H168.246L167.987 180.769L166 181ZM18.3858 181L16.3992 181.231L16.6047 183H18.3858V181ZM7 83V81H4.75418L5.01336 83.2308L7 83ZM7.17117 83V85H9.41907L9.15759 82.7674L7.17117 83ZM57.8519 71H6V75H57.8519V71ZM63.8474 82.2337L59.6992 72.2337L56.0045 73.7663L60.1526 83.7663L63.8474 82.2337ZM62 85H154.614V81H62V85ZM152.628 83.2308L164.013 181.231L167.987 180.769L156.601 82.7692L152.628 83.2308ZM166 179H18.3858V183H166V179ZM20.3725 180.769L8.98664 82.7692L5.01336 83.2308L16.3992 181.231L20.3725 180.769ZM7 85H7.17117V81H7V85ZM4.01358 73.2326L5.18475 83.2326L9.15759 82.7674L7.98642 72.7674L4.01358 73.2326Z",
    fill: "#CFD8DC",
    mask: "url(#path-3-inside-1_1552_71073)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinAlerts);
export default __webpack_public_path__ + "static/media/sin_alerts.7efbd949bcef82e6d7b497af87e52a54.svg";
export { ForwardRef as ReactComponent };